import Vue from 'vue'
import router from '../../../src/router'
import store from '../../../src/store'
import selectSign from '@/components/selectSignatory/selectSignatory'
import selectContract from '@/components/selectContract/selectContract'
import contractSign from '@/components/contractSign/contractSign'
import pdfPreview from '@/components/pdfPreview/pdfPreview'
import caCertifica from '@/components/caCertifica/caCertifica'
import electronicSeal from '@/components/drawElectronicSeal/drawElectronicSeal'
import usageRecord from '@/components/electroUsageRecord/electroUsageRecord'
import selectSealcom from '@/components/selectSeal/selectSeal'
import historyList from '@/components/historyList/historyList'
import lzWps from '@/components/lzWps/lzWps'
let lzElement
//这里做下用户被挤出登录的情况
router.beforeEach((to, from , next) => {
	if(to.name=='login'&&lzElement){
		lzElement.$children[0].cancelFn()
	}
    next()
});
//在线预览
function onlineWps(data){
	lzElement=new Vue({
		store,
		render(h){
			return h(lzWps,{
				props:{
					...data,
					close(){
						lzElement.$el.remove()
					},
					cancel(){
						let result={
							cancel:true,
							data:''
						}
						data.success&&data.success(result)
					},
					confirm(row){
						let result={
							confirm:true,
							data:row,
						}
						data.success&&data.success(result)
					}
				}
			})
		}
	}).$mount()
	document.body.appendChild(lzElement.$el)
	lzElement.$children[0].show(data)
}

//选取印章
function selectSeal(data){
	lzElement=new Vue({
		store,
		render(h){
			return h(selectSealcom,{
				props:{
					...data,
					close(){
						lzElement.$el.remove()
					},
					cancel(){
						let result={
							cancel:true,
							data:''
						}
						data.success&&data.success(result)
					},
					confirm(row){
						let result={
							confirm:true,
							data:row,
						}
						data.success&&data.success(result)
					}
				}
			})
		}
	}).$mount()
	document.body.appendChild(lzElement.$el)
	lzElement.$children[0].show(data)
}
//电子印章使用记录
function electroUsageRecord(data){
	lzElement = new Vue({
		store,
		render(h){
			return h(usageRecord,{
				props:{
					...data,
					close(){
						lzElement.$el.remove()
					},
					cancel(){
						let result={
							cancel:true,
							data:''
						}
						data.success&&data.success(result)
					},
					confirm(row){
						let result={
							confirm:true,
							data:row,
						}
						data.success&&data.success(result)
					}
				}
			})
		}
	}).$mount()
	document.body.appendChild(lzElement.$el)
	lzElement.$children[0].show(data)
}

//绘制电子章
function drawElectronicSeal(data){
	lzElement = new Vue({
		store,
		render(h){
			return h(electronicSeal,{
				props:{
					...data,
					close(){
						lzElement.$el.remove()
					},
					cancel(){
						let result={
							cancel:true,
							data:''
						}
						data.success&&data.success(result)
					},
					confirm(row){
						let result={
							confirm:true,
							data:row,
						}
						data.success&&data.success(result)
					}
				}
			})
		}
	}).$mount()
	document.body.appendChild(lzElement.$el)
	lzElement.$children[0].show(data)
}

//选取ca
function selectCACertifica(data={width:''}){
	lzElement = new Vue({
		store,
		render(h) {
			return h(caCertifica,{
				props:{
					...data,
					close(){
						lzElement.$el.remove()
					},
					cancel(){
						let result={
							cancel:true,
							data:''
						}
						data.success&&data.success(result)
					},
					confirm(row){
						let result={
							confirm:true,
							data:row,
						}
						data.success&&data.success(result)
					}
				}
			})
		}
	}).$mount()
	document.body.appendChild(lzElement.$el)
	lzElement.$children[0].show(data)
}
//pdf渲染
function pdfPreviewShow(data={width:""}){
	lzElement=new Vue({
		store,
		render:(h)=>{
			return h(pdfPreview,{
				props:{
					...data,
					close(){
						lzElement.$el.remove()
						let result={
							cancel:true,
							data:''
						}
						data.success&&data.success(result)
					},
					cancel(){
						let result={
							cancel:true,
							data:''
						}
						data.success&&data.success(result)
					},
					confirm(row){
						let result={
							confirm:true,
							data:row,
						}
						data.success&&data.success(result)
					},
				}
			})
		}
	}).$mount()
	document.body.appendChild(lzElement.$el)
	lzElement.$children[0].show()
}

//立即签署
function contractSignShow(data={width:"",title:''}){
	lzElement = new Vue({
		store:store,
		render:(h)=>{
			return h(contractSign,{
				props:{
					...data,
					close(){
						lzElement.$el.remove()
						this.$destroy(contractSign)
					},
					cancel(){
						let result={
							cancel:true,
							data:''
						}
						data.success&&data.success(result)
					},
					confirm(list){
						let result={
							confirm:true,
							data:list
						}
						data.success&&data.success(result)
					},
				}
			})
		}
	}).$mount()
	document.body.appendChild(lzElement.$el)
	lzElement.$children[0].show()
}
//选择电子合同
function contractShow(data={width:"",title:'',enterpriseId:''}){
	lzElement = new Vue({
		store:store,
		render: (h) => {
			return h(
				selectContract, {
					props: {
						...data,
						close(){
							lzElement.$el.remove()
						},
						cancel(){
							let result={
								cancel:true,
								data:''
							}
							data.success&&data.success(result)
						},
						confirm(list){
							let result={
								confirm:true,
								data:list
							}
							data.success&&data.success(result)
						},
					},
					
				}
			)
		}
	}).$mount()
	document.body.appendChild(lzElement.$el)
	lzElement.$children[0].show()
}

//选择签署方
function signatoryShow(data={width:"",title:'',enterpriseId:'',oldSelectList:[]}){
	lzElement = new Vue({
		store:store,
		render: (h) => {
			return h(
				selectSign, {
					props: {
						...data,
						close(){
							lzElement.$el.remove()
						},
						cancel(){
							let result={
								cancel:true,
								data:''
							}
							data.success&&data.success(result)
						},
						confirm(list){
							let result={
								confirm:true,
								data:list
							}
							data.success&&data.success(result)
						},
					},
					
				}
			)
		}
	}).$mount()
	document.body.appendChild(lzElement.$el)
	lzElement.$children[0].show(data)
}

// 动态向某个元素插入搜索历史组件
// 传入插入的元素class
function addHistoryList(className,data){
	lzElement = new Vue({
		store:store,
		render: (h) => {
			return h(
				historyList, {
					props: {
						...data,
						confirm(item){
							data.click&&data.click(item)
						},
					}
				}
			)
		}
	}).$mount()
	let element  = document.querySelector(className) // 获取dom元素
	element.appendChild(lzElement.$el)
	return lzElement
}

export default {
	signatoryShow,
	contractShow,
	contractSignShow,
	pdfPreviewShow,
	selectCACertifica,
	drawElectronicSeal,
	electroUsageRecord,
	selectSeal,
	addHistoryList,
	onlineWps
}


// WEBPACK FOOTER //
// ./static/js/function/ui.js